import PropTypes from 'prop-types'
import React from 'react'

export const VehicleRegistration = ({price}) => (
  <div className='oglasi-cijena-registracije'>
    <div className='oglasi-cijena-registracije-header'>
      <i className='ico-tab-specifikacija ico' />
      <p>Cijena registracije</p>
    </div>
    <div className='oglasi-cijena-registracije-content'>
      <p>Cijena registracije za ovo vozilo na premijski razred 7 iznosi oko&nbsp;
        <span className='registracija-info-cijena'>{price} &euro;</span>
      </p>
    </div>
  </div>
)

VehicleRegistration.propTypes = {
  price: PropTypes.number.isRequired
}
